import Axios from 'axios';
import { SubscriptionPlanDto } from '../types/subscriptions';

export const getPlans = async (): Promise<{ plans: SubscriptionPlanDto[] }> => {
  return (await Axios.get(`${process.env.REACT_APP_API_URL}/subscriptions/plans`)).data;
};
